/*
 *!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * Note: New functionalities have been added by Jacob Saoumi
 *
 * save panel + save event : they are used instead of the defaults buttons panel of the datepicker
 *
 * this functions should be must coppied to the new versions : _injectSavePanel, _onSaveHandler
 *
 * add to defaults :
 * onSave : null,  showSave: false,
 *
 * add to regional :
 * saveText : 'Save'
 *!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * HERES THE CSS:
 * .ui-timepicker-div .ui-widget-header { margin-bottom: 8px; }
 * .ui-timepicker-div dl { text-align: left; }
 * .ui-timepicker-div dl dt { height: 25px; margin-bottom: -25px; }
 * .ui-timepicker-div dl dd { margin: 0 10px 10px 65px; }
 * .ui-timepicker-div td { font-size: 90%; }
 * .ui-tpicker-grid-label { background: none; border: none; margin: 0; padding: 0; }
 */

export default (function ($) {
  $.extend($.ui, {
    mctimepicker: {
      version: '0.9.8',
    },
  });

  function McTimepicker() {
    this.regional = []; // Available regional settings, indexed by language code
    this.regional[''] = { // Default regional settings
      currentText: 'Now',
      closeText: 'Done',
      timeOnlyTitle: 'Choose Time',
      timeText: 'Time',
      hourText: 'Hour',
      minuteText: 'Minute',
      secondText: 'Second',
      saveText: 'Save',
    };

    this._defaults = { // Global _defaults for all the datetime picker instances
      showButtonPanel: false,
      defaultTime: '', // in format HH:MM:SS . ex. 18:02:00
      timeOnly: false,
      showHour: true,
      showMinute: true,
      showSecond: false,
      showTime: true,
      stepHour: 1,
      stepMinute: 1,
      stepSecond: 1,
      hour: 0,
      minute: 0,
      second: 0,
      hourMin: 0,
      minuteMin: 0,
      secondMin: 0,
      hourMax: 23,
      minuteMax: 59,
      secondMax: 59,
      onSave: null,
      onSelect: null,
      showTimepicker: true,
    };
    $.extend(this._defaults, this.regional['']);
  }

  $.extend(McTimepicker.prototype, {
    $input: null,
    $altInput: null,
    $timeObj: null,
    inst: null,
    hourSelect: null,
    minuteSelect: null,
    secondSelect: null,
    hour: 0,
    minute: 0,
    second: 0,
    hourMinOriginal: null,
    minuteMinOriginal: null,
    secondMinOriginal: null,
    hourMaxOriginal: null,
    minuteMaxOriginal: null,
    secondMaxOriginal: null,
    formattedDate: '',
    formattedTime: '',
    formattedDateTime: '',
    setDefaults(settings) {
      Object.assign(this._defaults, settings || {});
      return this;
    },
    // ########################################################################
    // Create a new McTimepicker instance
    // ########################################################################
    _newInst($input, o) {
      var tpInst = new McTimepicker();
      var inlineSettings = {};

      Object.keys(this._defaults).forEach((attrName) => {
        var attrValue = $input.attr(`time:${attrName}`);
        if (attrValue) {
          inlineSettings[attrName] = attrValue;
        }
      });
      tpInst._defaults = $.extend({}, this._defaults, inlineSettings, o, {
        beforeShow(input, dpInst) {
          if ($.isFunction(o.beforeShow)) {
            o.beforeShow(input, dpInst, tpInst);
          }
        },
        onChangeMonthYear(year, month, dpInst) {
          // Update the time as well : this prevents the time from disappearing from the $input field.
          tpInst._updateDateTime(dpInst);
          if ($.isFunction(o.onChangeMonthYear)) {
            o.onChangeMonthYear.call($input[0], year, month, dpInst, tpInst);
          }
        },
        onClose(dateText, dpInst) {
          if (tpInst.timeDefined === true && $input.val() != '') {
            tpInst._updateDateTime(dpInst);
          }
          if ($.isFunction(o.onClose)) {
            o.onClose.call($input[0], dateText, dpInst, tpInst);
          }
        },
        mctimepicker: tpInst, // add timepicker as a property of datepicker: $.datepicker._get(dpInst, 'timepicker');
      });

      tpInst.hour = tpInst._defaults.hour;
      tpInst.minute = tpInst._defaults.minute;
      tpInst.second = tpInst._defaults.second;
      tpInst.$input = $input;

      if (tpInst._defaults.minDate == 0) {
        tpInst._defaults.minDate = new Date();
      }
      if (tpInst._defaults.maxDate == 0) {
        tpInst._defaults.maxDate = new Date();
      }
      return tpInst;
    },

    // ########################################################################
    // add our sliders to the calendar
    // MC sd: fixed parseTime, so the select fields are updated
    // ########################################################################
    _addTimePicker(dpInst) {
      var currDT = dpInst.input.val().split(' ')[1];
      if (currDT) {
        this._parseTime(currDT);
      }
      if (!this.inst) {
        this.inst = $.datepicker._getInst(this.$input[0]);
      }
      this._injectTimePicker();
    },

    // ########################################################################
    // when a slider moves, set the internal time...
    // on time change is also called when the time is updated in the text field
    // ########################################################################
    _onTimeChange() {
      var o = this._defaults;

      var hour = (this.hourSelect ? this.hourSelect.val() : false);
      var minute = (this.minuteSelect ? this.minuteSelect.val() : false);
      var second = (this.secondSelect ? this.secondSelect.val() : false);

      if (typeof hour === 'object') {
        hour = false;
      }
      if (typeof minute === 'object') {
        minute = false;
      }
      if (typeof second === 'object') {
        second = false;
      }

      if (hour !== false) {
        hour = parseInt(hour, 10);
      }
      if (minute !== false) {
        minute = parseInt(minute, 10);
      }
      if (second !== false) {
        second = parseInt(second, 10);
      }

      // If the update was done in the input field, the input field should not be updated.
      // If the update was done using the sliders, update the input field.
      var hasChanged = (hour != this.hour || minute != this.minute || second != this.second);

      if (hasChanged) {
        if (hour !== false) {
          this.hour = hour;
        }
        if (minute !== false) {
          this.minute = minute;
        }
        if (second !== false) {
          this.second = second;
        }

        if (!this.inst) {
          this.inst = $.datepicker._getInst(this.$input[0]);
        }
      }

      this._formatTime();
      if (hasChanged) {
        this._updateDateTime();
      }
    },

    // ########################################################################
    // generate and inject html for timepicker into ui datepicker
    // ########################################################################
    _injectTimePicker() {
      var $dp = this.inst.dpDiv;
      var o = this._defaults;
      var tpInst = this;
      var hourMax = parseInt((o.hourMax - ((o.hourMax - o.hourMin) % o.stepHour)), 10);
      var minMax = parseInt((o.minuteMax - ((o.minuteMax - o.minuteMin) % o.stepMinute)), 10);
      var secMax = parseInt((o.secondMax - ((o.secondMax - o.secondMin) % o.stepSecond)), 10);
      var dpId = this.inst.id.toString().replace(/([^A-Za-z0-9_])/g, '');

      if ($dp.find(`div#ui-timepicker-div-${dpId}`).length === 0) {
        var html = `<div class="ui-timepicker-div" id="ui-timepicker-div-${dpId}"><table><tr><td style="width:25%;">${o.timeText}</td>`;
        html += '<td>';
        if (o.showHour) {
          let selecthtml = `<select id="ui_timepicker_hourdp_${dpId}" >`;
          for (let i = o.hourMin; i <= hourMax; i += o.stepHour) {
            selecthtml += `<option value="${i}">${i}</option>`;
          }
          selecthtml += '</select>';
          if (o.showMinute) {
            selecthtml += '&nbsp;:&nbsp;';
          }
          html += selecthtml;
        }
        if (o.showMinute) {
          let selecthtml = `<select id="ui_timepicker_mindp_${dpId}">`;
          for (let i = o.minuteMin; i <= minMax; i += o.stepMinute) {
            selecthtml += `<option value="${i}">${i}</option>`;
          }
          selecthtml += '</select>';
          if (o.showSecond) {
            selecthtml += '&nbsp;:&nbsp;';
          }
          html += selecthtml;
        }

        if (o.showSecond) {
          let selecthtml = `<select id="ui_timepicker_secdp_${dpId}" >`;
          for (let i = o.secondMin; i <= secMax; i += o.stepSecond) {
            selecthtml += `<option value="${i}">${i}</option>`;
          }
          selecthtml += '</select>';
          html += selecthtml;
        }
        html += '</td>';

        html += '</tr></table></div>';

        var $tp = $(html);
        // if we only want time picker...
        if (o.timeOnly === true) {
          $tp.prepend(`<div class="ui-widget-header ui-helper-clearfix ui-corner-all"><div class="ui-datepicker-title">${o.timeOnlyTitle}</div></div>`);
          $dp.find('.ui-datepicker-header, .ui-datepicker-calendar').hide();
        }

        if (o.defaultTime) {
          tpInst._parseTime(o.defaultTime);
        }

        this.hourSelect = $tp.find(`#ui_timepicker_hourdp_${dpId}`);
        this.minuteSelect = $tp.find(`#ui_timepicker_mindp_${dpId}`);
        this.secondSelect = $tp.find(`#ui_timepicker_secdp_${dpId}`);
        if (this.hourSelect.length > 0) {
          this.hourSelect.val(this.hour);
          this.hourSelect.on('change', () => {
            tpInst._onTimeChange();
          });
        } else {
          this.hourSelect = null;
        }
        if (this.minuteSelect.length > 0) {
          this.minuteSelect.val(this.minute);
          this.minuteSelect.on('change', () => {
            tpInst._onTimeChange();
          });
        } else {
          this.minuteSelect = null;
        }

        if (this.secondSelect > 0) {
          this.secondSelect.val(this.minute);
          this.secondSelect.on('change', () => {
            tpInst._onTimeChange();
          });
        } else {
          this.secondSelect = null;
        }

        var $buttonPanel = $dp.find('.ui-datepicker-buttonpane');
        if ($buttonPanel.length) {
          $buttonPanel.before($tp);
        } else {
          $dp.append($tp);
        }
      }
    },

    _parseTime(timeString) {
      this.hour = 0;
      this.minute = 0;
      this.second = 0;
      var aTimeparts = timeString.split(':');
      if (aTimeparts.length != 3) {
        return;
      }
      this.hour = Number(aTimeparts[0]);
      this.minute = Number(aTimeparts[1]);
      this.second = Number(aTimeparts[2]);
      return {
        hour: Number(aTimeparts[0]),
        minute: Number(aTimeparts[1]),
        second: Number(aTimeparts[2]),
      };
    },

    // ########################################################################
    // format the time all pretty...
    // ########################################################################
    _formatTime(time) {
      time = time || {
        hour: this.hour,
        minute: this.minute,
        second: this.second,
      };

      var hour = parseInt(time.hour, 10);
      var min = parseInt(time.minute, 10);
      var sec = parseInt(time.second, 10);

      this.formattedTime = `${hour.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
    },

    // ########################################################################
    // update our input with the new date time..
    // ########################################################################
    _updateDateTime(dpInst) {
      dpInst = this.inst || dpInst;
      var dt = $.datepicker._daylightSavingAdjust(new Date(dpInst.selectedYear, dpInst.selectedMonth, dpInst.selectedDay));
      var dateFmt = $.datepicker._get(dpInst, 'dateFormat');
      var formatCfg = $.datepicker._getFormatConfig(dpInst);
      this.formattedDate = $.datepicker.formatDate(dateFmt, (dt === null ? new Date() : dt), formatCfg);
      this.formattedDateTime = this.formattedDate;
      if (dpInst.lastVal !== undefined && (dpInst.lastVal.length > 0 && this.$input.val().length === 0)) {
        return;
      }
      this._formatTime();

      this.formattedDateTime = `${this.formattedDate} ${this.formattedTime}`;
      if (!this._defaults.showTimepicker) {
        this.$input.val(this.formattedDate);
      } else if (this.$altInput) {
        this.$altInput.val(this.formattedDateTime);
        this.$input.val(this.formattedDateTime);
      } else {
        this.$input.val(this.formattedDateTime);
      }

      this.$input.trigger('change');
    },

  });

  $.fn.extend({
    // ########################################################################
    // extend timepicker to datepicker
    // ########################################################################
    mcdatetimepicker(o, ...args) {
      o = o || {};
      var $input = this;
      var tmpArgs = [o, ...args];

      if (typeof o === 'string') {
        if (o === 'getDate') {
          var date = $.fn.datepicker.apply($(this[0]), tmpArgs);
          var currDT = $input.val().split(' ')[1];
          if (currDT && currDT.split(':').length == 3) {
            var time = $.mctimepicker._parseTime(currDT);
            date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.hour, time.minute, time.second);
          }
          return date;
        }
        return this.each(function () {
          var $t = $(this);
          $t.datepicker(...tmpArgs);
        });
      }
      return this.each(function () {
        var $t = $(this);
        $t.datepicker($.mctimepicker._newInst($t, o)._defaults);
      });
    },
  });

  // #######################################################################
  // hack :) now-function works as expected
  // #######################################################################

  $.datepicker._gotoToday = function (id) {
    var target = $(id)[0];
    var inst = this._getInst(target);
    var date = new Date();

    inst.selectedDay = date.getDate();
    inst.drawMonth = date.getMonth();
    inst.selectedMonth = date.getMonth();
    inst.drawYear = date.getFullYear();
    inst.selectedYear = date.getFullYear();

    var currHour = date.getHours();
    var currMinute = date.getMinutes();
    var dateString = `${currHour}:${currMinute}:00`;

    this._notifyChange(inst);
    this._adjustDate(target);
    this._setDateDatepicker(target, date);
    this._setTimeDatepicker(target, dateString);
  };

  // ########################################################################
  // the bad hack :/ override datepicker so it doesnt close on select
  // inspired: http://stackoverflow.com/questions/1252512/jquery-datepicker-prevent-closing-picker-when-clicking-a-date/1762378#1762378
  // ########################################################################
  $.datepicker._base_selectDate = $.datepicker._selectDate;
  $.datepicker._selectDate = function (id, dateStr) {
    var inst = this._getInst($(id)[0]);
    var tpInst = this._get(inst, 'mctimepicker');

    if (tpInst) {
      inst.inline = true;
      inst.stay_open = true;
      // This way the onSelect handler called from calendarpicker get the full dateTime
      this._base_selectDate(id, dateStr);
      inst.inline = false;
      inst.stay_open = false;
      this._notifyChange(inst);
      this._updateDatepicker(inst);
    } else {
      this._base_selectDate(id, dateStr);
    }
  };

  // #############################################################################################
  // second bad hack :/ override datepicker so it triggers an event when changing the input field
  // and does not redraw the datepicker on every selectDate event
  // #############################################################################################
  $.datepicker._base_updateDatepicker = $.datepicker._updateDatepicker;
  $.datepicker._updateDatepicker = function (inst) {
    // don't popup the datepicker if there is another instance already opened
    var input = inst.input[0];
    if ($.datepicker._curInst && $.datepicker._curInst != inst && $.datepicker._datepickerShowing && $.datepicker._lastInput != input) {
      return;
    }

    if (typeof inst.stay_open !== 'boolean' || inst.stay_open === false) {
      this._base_updateDatepicker(inst);

      // Reload the time control when changing something in the input text field.
      var tpInst = this._get(inst, 'mctimepicker');
      if (tpInst) {
        tpInst._addTimePicker(inst);
      }
    }
  };

  // #######################################################################################
  // override setDate() to allow setting time too within Date object
  // #######################################################################################
  $.datepicker._base_setDateDatepicker = $.datepicker._setDateDatepicker;
  $.datepicker._setDateDatepicker = function (target, date, ...args) {
    var inst = this._getInst(target);

    this._updateDatepicker(inst);
    this._base_setDateDatepicker(target, date, ...args);
    this._updateDatepicker(inst);
  };

  // #######################################################################################
  // Disable & enable the Time in the datetimepicker
  // #######################################################################################
  $.datepicker._disableTimepickerDatepicker = function (target, date, withDate) {
    var inst = this._getInst(target);
    var tpInst = this._get(inst, 'mctimepicker');
    $(target).datepicker('getDate'); // Init selected[Year|Month|Day]
    if (tpInst) {
      tpInst._defaults.showTimepicker = false;
      tpInst._updateDateTime(inst);
    }
  };

  $.datepicker._enableTimepickerDatepicker = function (target, date, withDate) {
    var inst = this._getInst(target);
    var tpInst = this._get(inst, 'mctimepicker');
    $(target).datepicker('getDate'); // Init selected[Year|Month|Day]
    if (tpInst) {
      tpInst._defaults.showTimepicker = true;
      tpInst._addTimePicker(inst); // Could be disabled on page load
      tpInst._updateDateTime(inst);
    }
  };

  // #######################################################################################
  // Create our own set time function
  // #######################################################################################
  $.datepicker._setTime = function (inst, date) {
    var tpInst = this._get(inst, 'mctimepicker');
    if (tpInst) {
      var defaults = tpInst._defaults; // calling _setTime with no date sets time to defaults
      var hour = date ? date.getHours() : defaults.hour;
      var minute = date ? date.getMinutes() : defaults.minute;
      var second = date ? date.getSeconds() : defaults.second;

      // check if within min/max times..
      if ((hour < defaults.hourMin || hour > defaults.hourMax) || (minute < defaults.minuteMin || minute > defaults.minuteMax) || (second < defaults.secondMin || second > defaults.secondMax)) {
        hour = defaults.hourMin;
        minute = defaults.minuteMin;
        second = defaults.secondMin;
      }

      tpInst.hour = hour;
      tpInst.minute = minute;
      tpInst.second = second;

      if (tpInst.hourSelect) {
        tpInst.hourSelect.val(hour);
      }
      if (tpInst.minuteSelect) {
        tpInst.minuteSelect.val(minute);
      }
      if (tpInst.secondSelect) {
        tpInst.secondSelect.val(second);
      }

      tpInst._updateDateTime(inst);
    }
  };

  // #######################################################################################
  // Create new public method to set only time, callable as $().datepicker('setTime', hh:mm:ss)
  // the only acceptable format is : hh:mm:ss
  // #######################################################################################
  $.datepicker._setTimeDatepicker = function (target, date) {
    var inst = this._getInst(target);
    var tpInst = this._get(inst, 'mctimepicker');

    if (tpInst) {
      this._setDateFromField(inst);
      var tpDate;
      if (date) {
        if (typeof date === 'string') {
          tpInst._parseTime(date);
          tpDate = new Date();

          tpDate.setFullYear(inst.currentYear, inst.currentMonth, inst.currentDay);
          tpDate.setHours(tpInst.hour, tpInst.minute, tpInst.second, 0);
        } else {
          tpDate = new Date(date.getTime());
        }
        if (tpDate.toString() === 'Invalid Date') {
          tpDate = undefined;
        }
        this._setTime(inst, tpDate);
      }
    }
  };

  $.mctimepicker = new McTimepicker(); // singleton instance
  $.mctimepicker.version = '0.9.8';
}(jQuery));
